import type { ActionContext } from 'vuex'

import type { ActionClass, IndexJobDTO, IndexState } from '../../../models'
import type { IndexJobService, IndexJobServiceDiscardParams } from '../../../services/interfaces'

import { CONTAINER } from '../../../config/inversify.config'

import { TYPES } from '../../../config/inversify.types'

export class DiscardJobAction implements ActionClass {
  static execute(
    this: void,
    context: ActionContext<IndexState, unknown>,
    params: IndexJobServiceDiscardParams,
  ): Promise<IndexJobDTO> {
    const service = CONTAINER.get<IndexJobService>(TYPES.IndexJobService)
    return service.discard(params)
  }
}
